import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cx from 'classnames';
import { navigateAction } from 'fluxible-router';

import PaginationBox from '../../../../common/pagination-box/pagination-box';
import { changeArticlesCurrentPage } from '../../reducers/loadArticlesSlice';
import { ARTICLES_ITEMS_PER_PAGE } from '../../../../../../constants';
import { selectArticlesCount, selectArticlesCurrentPage } from '../../reducers/articlesSelectors';

import styles from './ArticlesPagination.module.scss';

import { executeAction } from 'state/fluxible-context';
import { useTypedSelector } from 'state';

interface IArticlesPaginationProps {
  className?: string;
}

const ArticlesPagination: React.FC<IArticlesPaginationProps> = ({ className }) => {
  const currentPage = useSelector(selectArticlesCurrentPage);
  const articlesCount = useSelector(selectArticlesCount);
  const spotId = useTypedSelector(state => state.application.spotId);
  const dispatch = useDispatch();

  const onPageChanged = useCallback(
    (nextPage: number) => {
      dispatch(changeArticlesCurrentPage(nextPage - 1));
      const url = `/spot/${spotId}/moderation/articles/${nextPage}`;

      executeAction(navigateAction, {
        url
      });
    },
    [dispatch, spotId]
  );

  return (
    <div className={cx(styles.container, className)}>
      <PaginationBox
        itemsPerPage={ARTICLES_ITEMS_PER_PAGE}
        totalRecords={articlesCount}
        offset={currentPage * ARTICLES_ITEMS_PER_PAGE}
        onPageChanged={onPageChanged}
      />
    </div>
  );
};

export default ArticlesPagination;
